import { UploadFileUrl } from "../constants/Config";
import { FileResponse } from "../models/FileResponse";
import { LoginMetadata } from "../models/LoginMetadata";
import { PostFormData } from "./BaseService";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
export class FileService {

  public static async UploadFile(
    loginMetadata: LoginMetadata,
    file: File,
    fileDirectory: string,
    fileName: string
  ): Promise<any> {
    const blobString = await FileService.convertFileToBlobString(file);
    const saveFileResponse = await Filesystem.writeFile({
      path: fileDirectory,
      data: blobString,
      directory: Directory.Documents,
      encoding: Encoding.UTF8,
    });
    const readResponse = await FileService.readFileFromLocal(fileDirectory);
    const allpromise = Promise.all([saveFileResponse,readResponse]).then(res=>{
          let obj = {
            path:res[1].data
          }
          return obj;
        })
    const response1 = await allpromise;
    return response1;
  }

  static async convertFileToBlobString(file: File) {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const blobString = reader.result as string;
        resolve(blobString);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  static async readFileFromLocal(path){
    const contents = await Filesystem.readFile({
      path: path,
      directory: Directory.Documents,
      encoding: Encoding.UTF8,
    });
    return contents;
  }

  // public static async UploadFile(
  //   loginMetadata: LoginMetadata,
  //   file: File,
  //   fileDirectory: string,
  //   fileName: string
  // ): Promise<FileResponse> {
  //   const result = await PostFormData<FileResponse>(
  //     UploadFileUrl,
  //     loginMetadata,
  //     file,
  //     fileDirectory,
  //     fileName
  //   )
  //     .then((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       throw error;
  //     });
  //   return result;
  // }
}
